module.exports = __webpack_public_path__ + "static/media/roof_reference.26ddeaa4.png";